(function () {
  if (window.FGSProductLandingShellLoaded) return;
  window.FGSProductLandingShellLoaded = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.product-landing-section a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    var targetId;
    try { targetId = decodeURIComponent(href.slice(1)); } catch (error) { return; }
    var target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (window.location.hash !== href) window.history.pushState(null, '', href);
  });

  var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

  function updateHeroVideos() {
    document.querySelectorAll('.fgs-landing__hero-video').forEach(function (video) {
      if (motionPreference.matches) {
        video.pause();
        return;
      }
      if (video.paused) {
        var playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      }
    });
  }

  function updateLandingShell() {
    updateHeroVideos();
    var landingSections = Array.from(document.querySelectorAll('.product-landing-section'));
    var isHomepage = document.body.classList.contains('template-index');
    var header = document.querySelector('[data-header]');

    if (landingSections.length === 0) {
      document.body.classList.remove('product-landing-template', 'product-landing-overlay-header', 'product-landing-has-custom-footer');
      // the Flash header is sticky (it takes its own space), so pages need no top padding
      document.body.classList.remove('pt-16', 'md:pt-20');
      if (header && !isHomepage) {
        delete header.dataset.homepage;
        header.classList.remove('header-transparent');
        header.classList.add('bg-white', 'border-b', 'border-gray-200');
        var standardLogo = header.querySelector('[data-logo]');
        if (standardLogo && standardLogo.dataset.logoDark) standardLogo.src = standardLogo.dataset.logoDark;
      }
      return;
    }

    function hasRenderableContent(section) {
      var hasElementContent = Array.from(section.children).some(function (child) {
        return !['LINK', 'SCRIPT', 'STYLE', 'TEMPLATE'].includes(child.tagName);
      });
      var hasTextContent = Array.from(section.childNodes).some(function (child) {
        return child.nodeType === Node.TEXT_NODE && child.textContent.trim().length > 0;
      });
      return hasElementContent || hasTextContent;
    }

    var renderableLandingSections = landingSections.filter(hasRenderableContent);
    var templateSections = Array.from(document.querySelectorAll('[id^="shopify-section-template--"], main .shopify-section')).filter(hasRenderableContent);
    if (templateSections.length === 0) templateSections = renderableLandingSections;

    var firstLandingSection = renderableLandingSections[0] || landingSections[0];
    var firstTemplateSection = templateSections[0] || firstLandingSection;
    var hasLeadingHero = firstTemplateSection === firstLandingSection && Boolean(firstLandingSection.querySelector('.fgs-landing__hero'));
    var hasCustomFooter = Boolean(document.querySelector('.product-landing-section .fgs-landing__footer'));

    document.body.classList.add('product-landing-template');
    document.body.classList.toggle('product-landing-overlay-header', hasLeadingHero);
    document.body.classList.toggle('product-landing-has-custom-footer', hasCustomFooter);
    document.body.classList.remove('pt-16', 'md:pt-20');

    if (!header) return;

    if (hasLeadingHero) {
      header.dataset.homepage = '';
      header.classList.remove('bg-white', 'border-b', 'border-gray-200', 'header-scrolled');
      header.classList.add('header-transparent');
    } else {
      delete header.dataset.homepage;
      header.classList.remove('header-transparent');
      header.classList.add('bg-white', 'border-b', 'border-gray-200');
    }

    var logo = header.querySelector('[data-logo]');
    if (logo) {
      logo.src = hasLeadingHero ? logo.dataset.logoWhite : logo.dataset.logoDark;
      logo.classList.add('logo-ready');
    }
    window.dispatchEvent(new Event('scroll'));
  }

  function scheduleLandingShellUpdate() {
    window.requestAnimationFrame(updateLandingShell);
  }

  updateLandingShell();
  if (motionPreference.addEventListener) motionPreference.addEventListener('change', updateHeroVideos);
  else motionPreference.addListener(updateHeroVideos);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLandingShell, { once: true });
  document.addEventListener('shopify:section:load', scheduleLandingShellUpdate);
  document.addEventListener('shopify:section:unload', scheduleLandingShellUpdate);
  document.addEventListener('shopify:section:reorder', scheduleLandingShellUpdate);
})();
